import React from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

const DesktopFeatureView = ({
  inView,
  fadeInUp,
  featureIcons,
  featureTexts,
  images,
}) => {
  return (
    <div className="df-did-you-know-heading">
      <div className="df-terafac-live df-feature-column d-flex flex-row">
        <motion.div
          className="df-feature-first-column col-5"
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={fadeInUp}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <div className="df-first-pic-div">
            <img
              className="df-feature-first-pic"
              src={images.abbRobot}
              alt="ABB Robot"
              draggable={false}
            />
          </div>
          <div className="df-second-pic-div">
            <motion.img
              className="df-feature-second-pic"
              src={images.pnc}
              alt="PNC System"
              draggable={false}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              variants={fadeInUp}
              transition={{ duration: 1, delay: 0.4 }}
            />
            <motion.h1
              className="fs-xl-heading"
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              variants={fadeInUp}
              transition={{ duration: 1, delay: 0.6 }}
              style={{ fontFamily: "Audiowide", fontWeight: 400 }}
            >
              TERAFAC
            </motion.h1>
            <motion.img
              className="df-feature-third-pic"
              src={images.operator}
              alt="Operator"
              draggable={false}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              variants={fadeInUp}
              transition={{ duration: 1, delay: 0.8 }}
            />
          </div>
        </motion.div>
        <motion.div
          className="df-feature-second-column col-7"
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={fadeInUp}
          transition={{ duration: 1, delay: 1 }}
        >
          {featureTexts.map((text, index) => (
            <motion.div
              key={index}
              className={`col-9 df-features-div ${
                index % 2 === 1 ? "offset-2" : ""
              }`}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              variants={fadeInUp}
              transition={{ duration: 1, delay: 1 + index * 0.2 }}
            >
              <div className="df-icon-container">
                <Icon
                  icon={featureIcons[index]}
                  size={"30px"}
                  style={{ fontSize: "30px", color: "white" }}
                />
              </div>
              <h2 className="fs-xl-paras">{text}</h2>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default DesktopFeatureView;
